import { useId } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ENFlag = ({ sx, ...props }: SvgIconProps) => {
  const clipId = useId();

  return (
    <SvgIcon
      viewBox='0 0 25 25'
      fill='none'
      sx={{ width: '24px', height: '24px', fill: 'none', ...sx }}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M1.74783 24.5H23.2522C23.9435 24.4438 24.5 23.6125 24.5 22.6062V2.39375C24.5 1.35625 23.913 0.50625 23.1913 0.5H1.8087C1.08696 0.50625 0.5 1.35625 0.5 2.39375V22.6C0.5 23.6125 1.05652 24.4438 1.74783 24.5Z'
          fill='#FEFEFE'
        />
        <path
          d='M10.8217 14.8938V24.5H14.1609V14.8938H24.5V10.0938H14.1609V0.5H10.8217V10.0938H0.5V14.8938H10.8217Z'
          fill='#C8102E'
        />
        <path
          d='M15.2739 8.26875V0.5H23.2C23.7478 0.5125 24.2174 1.00625 24.4087 1.7L15.2739 8.26875Z'
          fill='#012169'
        />
        <path
          d='M15.2739 16.7313V24.5H23.2522C23.7783 24.4563 24.2217 23.9688 24.4087 23.3L15.2739 16.7313Z'
          fill='#012169'
        />
        <path
          d='M9.7087 16.7313V24.5H1.74783C1.22174 24.4563 0.773917 23.9688 0.591309 23.2875L9.7087 16.7313Z'
          fill='#012169'
        />
        <path
          d='M9.7087 8.26875V0.5H1.8C1.25218 0.5125 0.778265 1.0125 0.591309 1.7125L9.7087 8.26875Z'
          fill='#012169'
        />
        <path d='M0.5 8.50001H3.82609L0.5 6.10626V8.50001Z' fill='#012169' />
        <path d='M24.5 8.5H21.1565L24.5 6.09375V8.5Z' fill='#012169' />
        <path d='M24.5 16.5H21.1565L24.5 18.9063V16.5Z' fill='#012169' />
        <path d='M0.5 16.5H3.82609L0.5 18.8937V16.5Z' fill='#012169' />
        <path d='M24.5 2.53125L16.2174 8.5H18.0696L24.5 3.875V2.53125Z' fill='#C8102E' />
        <path d='M8.76522 16.5H6.91304L0.5 21.1125V22.4563L8.78261 16.5H8.76522Z' fill='#C8102E' />
        <path d='M5.07391 8.50623H6.92609L0.5 3.88123V5.21873L5.07391 8.50623Z' fill='#C8102E' />
        <path d='M19.9043 16.4938H18.0522L24.5 21.1375V19.8L19.9043 16.4938Z' fill='#C8102E' />
      </g>
      <path
        d='M12.5 0.25C19.2655 0.25 24.75 5.73451 24.75 12.5C24.75 19.2655 19.2655 24.75 12.5 24.75C5.73451 24.75 0.25 19.2655 0.25 12.5C0.25 5.73451 5.73451 0.25 12.5 0.25Z'
        fill='none'
        stroke='#DFE1E1'
        strokeWidth='0.5'
      />
      <defs>
        <clipPath id={clipId}>
          <path
            d='M0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ENFlag;
